import { siteInfo, footerLinks } from '@/mocks/homeData';

export default function Footer() {
  return (
    <footer id="footer" className="bg-foreground-950 text-background-100">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-8">
          <div className="col-span-2 md:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 bg-primary-500 rounded-lg flex items-center justify-center">
                <span className="text-background-50 font-heading text-base font-bold">91</span>
              </div>
              <span className="font-heading text-xl text-background-50">{siteInfo.name}</span>
            </div>
            <p className="text-sm text-foreground-300 leading-relaxed">
              全网黑料短视频聚合平台，海量黑料视频每日更新，黑料视频在线观看首选。
            </p>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="text-sm font-semibold text-background-50 mb-4">{group.title}</h4>
              <ul className="space-y-2.5">
                {group.links.map((link) => (
                  <li key={link}>
                    <a
                      href="#"
                      className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer"
                    >
                      {link}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-8 border-t border-foreground-800/50">
          <div className="mb-6">
            <h4 className="text-sm font-semibold text-background-50 mb-3">合作伙伴</h4>
            <p className="text-xs text-foreground-400">虚位以待，诚邀各平台及媒体合作</p>
          </div>

          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-400">
              &copy; {new Date().getFullYear()} {siteInfo.name} 版权所有。本站内容仅供娱乐参考，如有不实信息请联系我们处理。
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-xs text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">
                用户协议
              </a>
              <a href="#" className="text-xs text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">
                隐私政策
              </a>
              <a href="#" className="text-xs text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">
                免责声明
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}